<template>
  <div class="converter">
    <h1>雅思G类与CLB分数转换器</h1>
    
    <div class="converter-container">
      <div class="ielts-section">
        <h2>IELTS G类成绩</h2>
        <div class="input-group">
          <div class="input-item">
            <label>Reading</label>
            <select v-model="ielts.reading">
              <option v-for="score in ieltsScores" :key="score" :value="score">{{ score }}</option>
            </select>
          </div>
          <div class="input-item">
            <label>Writing</label>
            <select v-model="ielts.writing">
              <option v-for="score in ieltsScores" :key="score" :value="score">{{ score }}</option>
            </select>
          </div>
          <div class="input-item">
            <label>Listening</label>
            <select v-model="ielts.listening">
              <option v-for="score in ieltsScores" :key="score" :value="score">{{ score }}</option>
            </select>
          </div>
          <div class="input-item">
            <label>Speaking</label>
            <select v-model="ielts.speaking">
              <option v-for="score in ieltsScores" :key="score" :value="score">{{ score }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="arrow">
        <span>⇄</span>
      </div>

      <div class="clb-section">
        <h2>CLB等级</h2>
        <div class="result-group">
          <div class="result-item">
            <label>Reading</label>
            <div class="clb-result">CLB {{ clbLevels.reading }}</div>
          </div>
          <div class="result-item">
            <label>Writing</label>
            <div class="clb-result">CLB {{ clbLevels.writing }}</div>
          </div>
          <div class="result-item">
            <label>Listening</label>
            <div class="clb-result">CLB {{ clbLevels.listening }}</div>
          </div>
          <div class="result-item">
            <label>Speaking</label>
            <div class="clb-result">CLB {{ clbLevels.speaking }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="reference-table">
      <h3>对照表</h3>
      <table>
        <thead>
          <tr>
            <th>CLB</th>
            <th>Reading</th>
            <th>Writing</th>
            <th>Listening</th>
            <th>Speaking</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>10</td>
            <td>8.0-9.0</td>
            <td>7.5-8.0</td>
            <td>8.0-9.0</td>
            <td>7.5-8.0</td>
          </tr>
          <tr>
            <td>9</td>
            <td>7.0-7.5</td>
            <td>7.0</td>
            <td>7.5</td>
            <td>7.0</td>
          </tr>
          <tr>
            <td>8</td>
            <td>6.5</td>
            <td>6.5</td>
            <td>7.0</td>
            <td>6.5</td>
          </tr>
          <tr>
            <td>7</td>
            <td>6.0</td>
            <td>6.0</td>
            <td>6.0</td>
            <td>6.0</td>
          </tr>
          <tr>
            <td>6</td>
            <td>5.0-5.5</td>
            <td>5.5</td>
            <td>5.0-5.5</td>
            <td>5.5</td>
          </tr>
          <tr>
            <td>5</td>
            <td>4.0-4.5</td>
            <td>5.0</td>
            <td>4.5</td>
            <td>5.0</td>
          </tr>
          <tr>
            <td>4</td>
            <td>3.5</td>
            <td>4.0-4.5</td>
            <td>4.0</td>
            <td>4.0-4.5</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IELTSConverterView',
  data() {
    return {
      ieltsScores: [
        3.5, 4.0, 4.5, 5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 8.0, 8.5, 9.0
      ],
      ielts: {
        reading: 6.0,
        writing: 6.0,
        listening: 6.0,
        speaking: 6.0
      }
    }
  },
  computed: {
    clbLevels() {
      return {
        reading: this.convertToCLB('reading', this.ielts.reading),
        writing: this.convertToCLB('writing', this.ielts.writing),
        listening: this.convertToCLB('listening', this.ielts.listening),
        speaking: this.convertToCLB('speaking', this.ielts.speaking)
      }
    }
  },
  methods: {
    convertToCLB(skill, score) {
      const conversionTable = {
        reading: {
          10: [8.0, 8.5, 9.0],
          9: [7.0, 7.5],
          8: [6.5],
          7: [6.0],
          6: [5.0, 5.5],
          5: [4.0, 4.5],
          4: [3.5]
        },
        writing: {
          10: [7.5, 8.0],
          9: [7.0],
          8: [6.5],
          7: [6.0],
          6: [5.5],
          5: [5.0],
          4: [4.0, 4.5]
        },
        listening: {
          10: [8.0, 8.5, 9.0],
          9: [7.5],
          8: [7.0],
          7: [6.0],
          6: [5.0, 5.5],
          5: [4.5],
          4: [4.0]
        },
        speaking: {
          10: [7.5, 8.0],
          9: [7.0],
          8: [6.5],
          7: [6.0],
          6: [5.5],
          5: [5.0],
          4: [4.0, 4.5]
        }
      }

      for (const [clb, scores] of Object.entries(conversionTable[skill])) {
        if (scores.includes(score)) {
          return clb;
        }
      }
      return '4以下';
    }
  }
}
</script>

<style scoped>
.converter {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  text-align: center;
  color: #333;
  margin-bottom: 30px;
}

.converter-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}

.ielts-section,
.clb-section {
  flex: 1;
  background: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
}

.arrow {
  padding: 0 20px;
  font-size: 24px;
  color: #666;
}

.input-group,
.result-group {
  display: grid;
  gap: 15px;
}

.input-item,
.result-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

label {
  font-weight: bold;
  color: #444;
}

select {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
}

.clb-result {
  padding: 8px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  text-align: center;
  font-weight: bold;
  color: #2c3e50;
}

.reference-table {
  margin-top: 40px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  background: #fff;
}

th, td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: center;
}

th {
  background: #f0f0f0;
  font-weight: bold;
}

tr:nth-child(even) {
  background: #f9f9f9;
}
</style>